import type { ConstructionTimelinePhase } from "../types";

/**
 * Offline fallback — ids are numeric strings aligned with `master_construction_timeline_phase.id`
 * after `npm run seed:timeline:mysql -w server` (typically "1" … "10").
 */
export const initialConstructionTimelinePhases: ConstructionTimelinePhase[] = [
  { id: "1", title: "Home Design & Approval", approxDays: 46, sortOrder: 1, createdAt: "2025-01-01T00:00:00.000Z" },
  { id: "2", title: "Excavation", approxDays: 14, sortOrder: 2, createdAt: "2025-01-01T00:00:00.000Z" },
  { id: "3", title: "Footing & Foundation", approxDays: 41, sortOrder: 3, createdAt: "2025-01-01T00:00:00.000Z" },
  { id: "4", title: "RCC Work - Columns & Slabs", approxDays: 17, sortOrder: 4, createdAt: "2025-01-01T00:00:00.000Z" },
  { id: "5", title: "Roof Slab", approxDays: 37, sortOrder: 5, createdAt: "2025-01-01T00:00:00.000Z" },
  { id: "6", title: "Brickwork and Plastering", approxDays: 8, sortOrder: 6, createdAt: "2025-01-01T00:00:00.000Z" },
  { id: "7", title: "Flooring & Tiling", approxDays: 25, sortOrder: 7, createdAt: "2025-01-01T00:00:00.000Z" },
  { id: "8", title: "Electric Wiring", approxDays: 14, sortOrder: 8, createdAt: "2025-01-01T00:00:00.000Z" },
  { id: "9", title: "Water Supply & Plumbing", approxDays: 30, sortOrder: 9, createdAt: "2025-01-01T00:00:00.000Z" },
  { id: "10", title: "Door", approxDays: 15, sortOrder: 10, createdAt: "2025-01-01T00:00:00.000Z" },
];
